export const iconFontAwesomeMediaplaybackForwardFast = (
	<i className="fa-solid fa-forward-fast"></i>
);
